<template>
  <div>
    <el-row :gutter="12">
      <el-col :span="14">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>任务状态</span>
            <span style="color: red" v-if="tj.flag">(PE字数为0)</span>
          </div>
          <div class="card_cont">
            <section v-if="flowLevel == 3 || flowLevel == 5">
              <p class="p1">
                翻译总计：
                <span class="f-w-600">共{{ tj.peSentNum || 0 }}句</span>
              </p>
              <ul class="card_ul">
                <li>
                  <span>待封包</span>
                  <span>{{ tj.pePoolSentNum || 0 }}句</span>
                </li>
                <li>
                  <span>待领取</span>
                  <span class="secondBox">
                    {{ tj.peWaitCount || 0 }} 包（共{{
                      tj.peWaitSentNum || 0
                    }}句）
                    <el-tooltip
                      content="被打回任务池的句子数"
                      placement="top-start"
                      effect="dark"
                    >
                      <span>（包含打回{{ tj.returnPeWaitSentNum }}句）</span>
                    </el-tooltip>
                  </span>
                  <el-button
                    v-if="
                      (orderTag == 2 || orderTag == 5) &&
                      permissions.dot_globalpush
                    "
                    :disabled="!isShowPePush"
                    type="text"
                    round
                    size="mini"
                    @click="globalPush(3)"
                  >
                    全局推送
                  </el-button>
                  <el-button
                    v-if="tj.peWaitCount > 0 && permissions.dot_repush"
                    type="text"
                    round
                    size="mini"
                    @click="rePush(3)"
                  >
                    重新推送
                  </el-button>
                  <span>正在推送人数:{{ pePush || 0 }}</span>
                  <el-button
                    v-if="pePush > 0"
                    type="text"
                    round
                    size="mini"
                    style="padding-left: 0px"
                    @click="pushDetail(3)"
                  >
                    查看
                  </el-button>
                </li>
                <li>
                  <span>进行中</span>
                  <span class="secondBox">
                    {{ tj.peProceedCount || 0 }} 包（共{{
                      tj.peProceedSentNum || 0
                    }}句）
                    <el-tooltip
                      content="被打回修改的句子数"
                      placement="top-start"
                      effect="dark"
                    >
                      <span>（包含打回{{ tj.peModifySentNum }}句）</span>
                    </el-tooltip>
                  </span>
                  <el-button
                    v-if="tj.peProceedCount > 0"
                    type="text"
                    round
                    size="mini"
                    :disabled="this.canPushRemind['peRemind'] != null"
                    @click="remind(3)"
                  >
                    消息提醒
                  </el-button>
                </li>
                <li>
                  <span>已提交</span>
                  <span>{{ tj.peSubmitSentNum || 0 }}句</span>
                </li>
                <li>
                  <span>已取消</span>
                  <span>{{ tj.peCancelSentNum || 0 }}句</span>
                  <span>&nbsp;</span>
                </li>
                <li v-if="isMtOut">
                  <span>机翻直出</span>
                  <span>{{ mtInfo.mtoutSentNum || 0 }}句</span>
                </li>
                <li v-if="isMtOut">
                  <span>例句填充</span>
                  <span>{{ mtInfo.exampleSentNum || 0 }}句</span>
                </li>
              </ul>
            </section>
            <section v-if="flowLevel == 4 || flowLevel == 5">
              <p class="p1">
                审核总计：
                <span class="f-w-600">共{{ tj.peSentNum || 0 }}句</span>
              </p>
              <ul class="card_ul">
                <li>
                  <span>待封包</span>
                  <span>{{ tj.auditPoolSentNum || 0 }}句</span>
                </li>
                <li>
                  <span>待领取</span>
                  <span class="secondBox">
                    {{ tj.auditWaitCount || 0 }} 包（共{{
                      tj.auditWaitSentNum || 0
                    }}句）
                    <el-tooltip
                      content="被质控打回任务池的句子数"
                      placement="top-start"
                      effect="dark"
                    >
                      <span>（包含打回{{ tj.returnAuditWaitSentNum }}句）</span>
                    </el-tooltip>
                  </span>
                  <el-button
                    v-if="
                      (orderTag == 2 || orderTag == 5) &&
                      permissions.dot_globalpush
                    "
                    :disabled="!isShowPeAuditPush"
                    type="text"
                    round
                    size="mini"
                    @click="globalPush(4)"
                  >
                    全局推送
                  </el-button>
                  <el-button
                    v-if="tj.auditWaitCount > 0 && permissions.dot_repush"
                    type="text"
                    round
                    size="mini"
                    @click="rePush(4)"
                  >
                    重新推送
                  </el-button>
                  <span>正在推送人数:{{ peAuditPush || 0 }}</span>
                  <el-button
                    v-if="peAuditPush > 0"
                    type="text"
                    round
                    size="mini"
                    style="padding-left: 0px"
                    @click="pushDetail(4)"
                  >
                    查看
                  </el-button>
                </li>
                <li>
                  <span>进行中</span>
                  <span class="secondBox">
                    {{ tj.auditProceedCount || 0 }} 包（共{{
                      tj.auditProceedSentNum || 0
                    }}句）
                    <el-tooltip
                      content="打回PE修改的句子数"
                      placement="top-start"
                      effect="dark"
                    >
                      <span>
                        （包含打回{{ tj.auditReturnModifySentNum }}句）
                      </span>
                    </el-tooltip>
                  </span>
                  <el-button
                    v-if="tj.auditProceedCount > 0"
                    type="text"
                    round
                    size="mini"
                    :disabled="this.canPushRemind['peAuditRemind'] != null"
                    @click="remind(4)"
                  >
                    消息提醒
                  </el-button>
                </li>
                <li>
                  <span>已提交</span>
                  <span>{{ tj.auditSubmitSentNum || 0 }}句</span>
                </li>
                <li>
                  <span>已取消</span>
                  <span>{{ tj.auditCancelSentNum || 0 }}句</span>
                  <span>&nbsp;</span>
                </li>
                <li v-if="isMtOut">
                  <span>机翻直出</span>
                  <span>{{ mtInfo.mtoutSentNum || 0 }}句</span>
                </li>
                <li v-if="isMtOut">
                  <span>例句填充</span>
                  <span>{{ mtInfo.exampleSentNum || 0 }}句</span>
                </li>
              </ul>
            </section>
          </div>
        </el-card>
      </el-col>
      <el-col :span="10">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>翻译结果</span>
          </div>
          <div class="card_cont">
            <ul class="card_ul right_card_ul">
              <li v-if="flowLevel == 3">
                <span>PE修改句子数</span>
                <span>
                  {{ tj.peModifyMtSentNum || 0 }}句（{{
                    tj.peModifyMtCount || 0
                  }}次）
                </span>
                <span>
                  {{
                    (
                      ((tj.peModifyMtSentNum || 0) / (tj.peSentNum || 1)) *
                      100
                    ).toFixed(2)
                  }}%
                </span>
              </li>
              <li v-if="flowLevel == 5">
                <span>打回任务池</span>
                <span>
                  {{ tj.auditPePoolSentNum || 0 }}句（{{
                    tj.auditPePoolCount || 0
                  }}次）
                </span>
                <span>
                  {{
                    (
                      ((tj.auditPePoolSentNum || 0) / (tj.peSentNum || 1)) *
                      100
                    ).toFixed(2)
                  }}%
                </span>
              </li>
              <p></p>
              <li v-if="flowLevel == 5">
                <span>打回译员修改</span>
                <span>
                  {{ tj.auditPeModifySentNum || 0 }}句（{{
                    tj.auditPeModifyCount || 0
                  }}次）
                </span>
                <span>
                  {{
                    (
                      ((tj.auditPeModifySentNum || 0) / (tj.peSentNum || 1)) *
                      100
                    ).toFixed(2)
                  }}%
                </span>
              </li>
              <p></p>
              <li v-if="flowLevel == 5">
                <span>初审直接通过</span>
                <span>
                  {{ tj.auditFirstPassCount || 0 }}句（{{
                    tj.auditFirstPassCount || 0
                  }}次）
                </span>
                <span>
                  {{
                    (
                      ((tj.auditFirstPassCount || 0) / (tj.peSentNum || 1)) *
                      100
                    ).toFixed(2)
                  }}%
                </span>
              </li>
              <p></p>
              <li v-if="flowLevel == 4 || flowLevel == 5">
                <span>终审修改</span>
                <span>
                  {{ tj.auditModifySentNum || 0 }}句（{{
                    tj.auditModifyCount || 0
                  }}次）
                </span>
                <span>
                  {{
                    (
                      ((tj.auditModifySentNum || 0) / (tj.peSentNum || 1)) *
                      100
                    ).toFixed(2)
                  }}%
                </span>
              </li>
            </ul>
            <div class="c-danger f-s-14">
              <div class="m-b-10 f-w-600">说明：</div>
              <p class="m-b-10" v-if="flowLevel == 3">
                <span class="f-w-600">PE修改句子数：</span>
                统计PE有修改机翻译文的句子数；百分比为PE修改过译文的句子数在所有句子中的占比；
              </p>
              <p class="m-b-10" v-if="flowLevel == 5">
                <span class="f-w-600">打回任务池：</span>
                统计审核打回PE任务池的句子数（句子数去重），和次数（次数不去重）；即同一个句子可能被打回任务池多次；
              </p>
              <p class="m-b-10" v-if="flowLevel == 5">
                <span class="f-w-600">打回译员修改：</span>
                统计审核打回PE修改的句子数（句子数去重），和次数（次数不去重）；即同一个句子可能被打回译员修改多次；
              </p>
              <p class="m-b-10" v-if="flowLevel == 5">
                <span class="f-w-600">初审直接通过：</span>
                统计审核初审（此句子未被打回修改或打回任务池过）时，直接通过的句子数；句子数应该等于次数；
              </p>
              <p class="m-b-10" v-if="flowLevel == 4 || flowLevel == 5">
                <span class="f-w-600">终审修改：</span>
                统计审核修改过的句子数（句子数去重），和次数（次数不去重）；即同一个句子可能被审核修改多次；（质控会打回到终审池）
              </p>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-drawer
      title="推送详情"
      :visible.sync="drawer"
      :before-close="handleClose"
      direction="ltr"
      size="75%"
    >
      <pushDetail
        :orderId="orderId"
        :type="type"
        key="pushDetails"
        ref="pushDetails"
      />
    </el-drawer>
  </div>
</template>

<script>
import { getTJInfo } from '@/api/dot/pe';
import {
  rePush,
  remind,
  gerRedisPushRemind,
  pushDetailTj,
  pushStatusByOrderId,
  rePushAll,
} from '@/api/dot/order';
import { getDotOrderWordTj } from '@/api/dot/qc';
import { statistics } from '@/api/dot/flow';
import { alertErroMsg, alertSuccessMsg } from '@/util/commonMsg';
import { mapGetters } from 'vuex';
import pushDetail from '@/views/common/pushDetail';

export default {
  props: ['flowLevel', 'orderId', 'orderTag', 'staParams', 'isMtOut'],
  components: { pushDetail },
  data() {
    return {
      drawer: false,
      tj: {},
      type: 0,
      pePush: 0,
      peAuditPush: 0,
      canPushRemind: {},
      isShowPePush: false,
      isShowPeAuditPush: false,
      mtInfo: {},
    };
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  mounted() {},
  methods: {
    init() {
      getTJInfo(this.orderId).then((response) => {
        this.tj = response.data.data;
      });
      gerRedisPushRemind(this.orderId, 4).then((response) => {
        this.canPushRemind = response.data.data;
      });

      pushDetailTj(this.orderId, 3).then((res) => {
        this.pePush = res.data.data.trNum;
      });

      pushDetailTj(this.orderId, 4).then((res) => {
        this.peAuditPush = res.data.data.trNum;
      });

      pushStatusByOrderId(this.orderId).then((res) => {
        this.isShowPePush = res.data.data.pePush;
        this.isShowPeAuditPush = res.data.data.peAuditPush;
      });

      if (this.isMtOut) {
        getDotOrderWordTj({
          orderId: this.orderId,
        }).then((res) => {
          this.mtInfo = res?.data?.data;
        });
      }
    },

    handleClose() {
      this.type = 0;
      this.drawer = false;
      statistics(
        Object.assign(
          {
            event_name: '查看',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },

    pushDetail(type) {
      this.drawer = true;
      this.type = type;
    },

    rePush(type) {
      rePush(this.orderId, type).then((res) => {
        if (res.data.data > 0) {
          alertSuccessMsg();
        } else if (res.data.data === -2) {
          alertErroMsg('请勿重复操作');
        } else if (res.data.data === -3) {
          alertErroMsg('没查到待领取包');
        } else if (res.data.data === -4) {
          alertErroMsg('流程不在进行中');
        } else {
          alertErroMsg('操作失败');
        }
      });
      statistics(
        Object.assign(
          {
            event_name: '重新推送',
            event_type: 'click',
            class_name: 'rePush',
            class_url: '/dotadmin/dotadmin/order/rePush/',
            event_params: '{id: this.orderId, taskType: type}',
          },
          this.staParams,
        ),
      );
    },

    remind(type) {
      this.$alert('24小时内只能提醒一次，确定发送？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        callback: (action) => {
          if (action === 'confirm') {
            remind(this.orderId, type).then((res) => {
              if (res.data.data > 0) {
                alertSuccessMsg();
              } else if (res.data.data === -2) {
                alertErroMsg('请勿重复操作');
              } else if (res.data.data === -3) {
                alertErroMsg('没查到待领取包');
              } else if (res.data.data === -4) {
                alertErroMsg('流程不在进行中');
              } else {
                alertErroMsg('操作失败');
              }
            });
          }
        },
      });
    },

    //全局推送
    globalPush(type) {
      rePushAll(this.orderId, type).then((res) => {
        if (res.data.data > 0) {
          alertSuccessMsg();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-card {
  background: #fafafa;
  .el-card__header {
    padding: 12px 20px;
  }
  .card_cont {
    .p1 {
      font-size: 16px;
      margin: 0;
    }
    .note {
      font-size: 12px;
      margin-top: 10px;
    }

    .card_ul {
      height: 200px;
      > li {
        width: 100%;
        list-style-type: none;
        > span {
          width: 20%;
          display: inline-block;
          margin-right: 2%;
          font-size: 14px;
        }
        .secondBox {
          width: 35%;
        }
        button {
          font-size: 14px;
        }
      }
    }
    .right_card_ul {
      height: 140px;
    }
  }
}
</style>
